/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Row, Select, Checkbox, Button } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { FC } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm } from '../types'
import {
    StyledSpan,
    StyledFormItem,
    StyledInput,
    StyledInputOptional,
} from '../methods.styles'
import { arrangementOptions } from '../../../../const'
import { extractComponentName } from '../../../functions'

type Props = {
    form: CustomFormInstance<MachineForm>
}

// type Values = MachineForm

const ImportantComponentsArrangements: FC<Props> = ({ form }) => {
    return (
        <Form.List name="importantComponentsArrangements">
            {(fields, { add, remove }) => {
                const primaryOptions = form.getFieldValue<
                    MachineForm['partsOfIndependentClaim']
                >('partsOfIndependentClaim')
                const formatedOptions = primaryOptions.map((item: string) => {
                    return extractComponentName(item, form)
                })
                return (
                    <>
                        {fields.map((field) => (
                            <Form.Item style={{ marginBottom: '24px' }}>
                                <Row align="middle" gutter={[12, 0]}>
                                    <Col span={10}>
                                        <Form.Item noStyle shouldUpdate>
                                            {() => (
                                                <Form.Item
                                                    {...field}
                                                    label="1st component"
                                                    name={[
                                                        field.name,
                                                        '1stComponent',
                                                    ]}
                                                    fieldKey={[
                                                        field.fieldKey as number,
                                                        '1stComponent',
                                                    ]}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                '1st component is required',
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        options={formatedOptions.map(
                                                            (
                                                                item: string,
                                                                index: number
                                                            ) => ({
                                                                value: primaryOptions[
                                                                    index
                                                                ],
                                                                label: item,
                                                            })
                                                        )}
                                                    />
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col flex={1}>
                                        <Form.Item noStyle shouldUpdate>
                                            {() => (
                                                <Form.Item
                                                    {...field}
                                                    label="2nd component"
                                                    name={[
                                                        field.name,
                                                        '2ndComponent',
                                                    ]}
                                                    fieldKey={[
                                                        field.fieldKey as number,
                                                        '2ndComponent',
                                                    ]}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                '2nd component is required',
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        options={formatedOptions.map(
                                                            (
                                                                item: string,
                                                                index: number
                                                            ) => ({
                                                                value: primaryOptions[
                                                                    index
                                                                ],
                                                                label: item,
                                                            })
                                                        )}
                                                    />
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={2.5}>
                                        <MinusCircleOutlined
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                            style={{
                                                color: '#f00',
                                                fontSize: '1.6rem',
                                                marginTop: '0.6rem',
                                            }}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name={[field.name, 'notSet']}
                                            valuePropName="checked"
                                            style={{ marginBottom: '20px' }}
                                        >
                                            <Checkbox>
                                                I want to describe the
                                                arrangement
                                            </Checkbox>
                                        </Form.Item>
                                    </Col>
                                    {!form.getFieldValue<
                                        MachineForm['importantComponentsArrangements']
                                    >('importantComponentsArrangements')[
                                        field.name
                                    ]?.notSet ? (
                                        <Col span={24}>
                                            <Form.Item noStyle shouldUpdate>
                                                {() => (
                                                    <Form.Item
                                                        {...field}
                                                        label="Arrangement type"
                                                        name={[
                                                            field.name,
                                                            'arrangementType',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'arrangementType',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    'Arrangement type is required',
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            options={
                                                                arrangementOptions
                                                            }
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    ) : (
                                        <Col span={24}>
                                            <Form.Item
                                                noStyle
                                                name={[
                                                    field.name,
                                                    'additionalArrangementInfo',
                                                ]}
                                                rules={[
                                                    {
                                                        validator: async () => {
                                                            const importantComponentsArrangements =
                                                                form.getFieldValue<
                                                                    MachineForm['importantComponentsArrangements']
                                                                >(
                                                                    'importantComponentsArrangements'
                                                                )[field.key]
                                                            if (
                                                                importantComponentsArrangements &&
                                                                importantComponentsArrangements.notSet
                                                            ) {
                                                                const errorList =
                                                                    []
                                                                if (
                                                                    importantComponentsArrangements[
                                                                        '2ndPart'
                                                                    ] == null ||
                                                                    importantComponentsArrangements[
                                                                        '2ndPart'
                                                                    ] === ''
                                                                ) {
                                                                    errorList.push(
                                                                        ' 2nd part of description is required'
                                                                    )
                                                                }
                                                                if (
                                                                    errorList.length >
                                                                    0
                                                                ) {
                                                                    throw new Error(
                                                                        errorList.toString()
                                                                    )
                                                                }
                                                            }
                                                        },
                                                    },
                                                ]}
                                            >
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '1stPart',
                                                    ]}
                                                >
                                                    <StyledInputOptional
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                                <StyledSpan>
                                                    the{' '}
                                                    {extractComponentName(
                                                        form.getFieldValue<
                                                            MachineForm['importantComponentsArrangements']
                                                        >(
                                                            'importantComponentsArrangements'
                                                        )[field.key]?.[
                                                            '1stComponent'
                                                        ],
                                                        form
                                                    ) ?? '1st Component'}
                                                </StyledSpan>
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '2ndPart',
                                                    ]}
                                                >
                                                    <StyledInput
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                                <StyledSpan>
                                                    the{' '}
                                                    {extractComponentName(
                                                        form.getFieldValue<
                                                            MachineForm['importantComponentsArrangements']
                                                        >(
                                                            'importantComponentsArrangements'
                                                        )[field.key]?.[
                                                            '2ndComponent'
                                                        ],
                                                        form
                                                    ) ?? '2nd Component'}
                                                </StyledSpan>
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '3rdPart',
                                                    ]}
                                                >
                                                    <StyledInputOptional
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block>
                                Add arrangement
                            </Button>
                        </Form.Item>
                    </>
                )
            }}
        </Form.List>
    )
}

export default ImportantComponentsArrangements
